import React from "react";
import { makeStyles } from "@mui/styles";

interface PropsI {
  children: React.ReactNode;
}

const useStyles = makeStyles((theme) => {
  return {
    styles: {
      width: "90%",
      margin: "0 auto",
      [theme.breakpoints.down("md")]: {
        width:"calc(100% - 16px)",
      },
      [theme.breakpoints.up("xl")]: {
      }
    },
  };
});
const ContainerMain = ({ children }: PropsI) => {
  const classes = useStyles();
  return <div className={classes.styles}>{children}</div>;
};

export default ContainerMain;
